import { makeRequest, CommonRequestOptions } from '../makeRequest';

export async function deleteExternalTrainingModules(
   external_training_moduleids: number[],
   common: CommonRequestOptions = {}
): Promise<void> {
   return makeRequest('post', `/external_training_modules/bulkDelete`, {
      ...common,
      body: {
         external_training_moduleids,
      },
   });
}
